import React from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { PageBand } from '../v2/shared';
import { useAuth } from '../contexts/AuthContext';
import ProfessionalAgenda from '../components/ProfessionalAgenda';
import RentRooms from '../components/RentRooms';
import RoomOccupancy from '../components/RoomOccupancy';
import ProfessionalMonthlySummary from '../components/ProfessionalMonthlySummary';
import { firstName } from '../utils/clinicTime';

const TABS = [
  { to: 'agenda', label: 'Mi agenda' },
  { to: 'rent', label: 'Alquilar consultorio' },
  { to: 'rooms', label: 'Calendario de consultorios' },
  { to: 'monthly-summary', label: 'Mis cobros' },
];

/** Professional area: what is booked (agenda), renting rooms, and what is owed. Administrators use /admin instead. */
const ProfessionalDashboard: React.FC = () => {
  const { professional, user, loading } = useAuth();

  if (loading) {
    return <div className="flex min-h-64 items-center justify-center"><div className="h-12 w-12 animate-spin rounded-full border-b-2 border-primary-600" /></div>;
  }
  if (user?.role === 'admin') return <Navigate to="/admin" replace />;
  if (user?.role !== 'professional') {
    return (
      <div className="flex min-h-64 items-center justify-center text-center">
        <div><h2 className="mb-2 text-xl font-semibold text-gray-900">Acceso denegado</h2><p className="text-gray-600">No tenés permisos para entrar a esta página.</p></div>
      </div>
    );
  }

  return (
    <>
      <PageBand
        title="Mi panel"
        subtitle={`Hola, ${firstName(professional?.user?.name || user.name) || 'profesional'}. Mirá tu agenda, alquilá consultorios y revisá lo que debés.`}
      />
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <nav className="mb-8 flex space-x-8 overflow-x-auto whitespace-nowrap border-b border-gray-200" aria-label="Secciones">
          {TABS.map(t => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) => `-mb-px shrink-0 border-b-2 px-1 py-2 text-sm ${isActive ? 'border-accent-gold font-semibold text-primary-800' : 'border-transparent font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700'}`}
            >
              {t.label}
            </NavLink>
          ))}
        </nav>

        <Routes>
          <Route path="" element={<Navigate to="agenda" replace />} />
          <Route path="agenda" element={<ProfessionalAgenda />} />
          <Route path="rent" element={<RentRooms />} />
          <Route path="rooms" element={<RoomOccupancy mode="professional" />} />
          <Route path="monthly-summary" element={<ProfessionalMonthlySummary professionalId={String(professional?.id || '')} />} />
          {/* old addresses */}
          <Route path="room-availability" element={<Navigate to="../rent" replace />} />
          <Route path="availability" element={<Navigate to="../agenda" replace />} />
          <Route path="*" element={<Navigate to="agenda" replace />} />
        </Routes>
      </div>
    </>
  );
};

export default ProfessionalDashboard;
